<template>
  <UserPermissionGuard permission="can_edit">
    <v-layout full-height>
      <AppNavigationDrawer v-model="drawer" :mobile="smAndDown">
        <template #title-text>
          <v-btn
            class="px-0"
            variant="plain"
            :to="{ name: '/ops/' }"
            style="font-size: inherit"
          >
            {{ t('ops.cases') }}
          </v-btn>
        </template>
        <template #title-append>
          <v-btn
            size="x-small"
            icon="add"
            :to="{ name: '/ops/case/create' }"
            :active="false"
            v-tooltip="{ text: t('ops.case.create'), openDelay: 800 }"
          />
        </template>

        <OpsTreeView class="overflow-auto pt-0 px-1" />
      </AppNavigationDrawer>

      <v-main tag="div" class="transition-none" scrollable>
        <AppNavigationDrawerExpandButton
          v-if="smAndDown"
          v-model="drawer"
          class="ml-1 mt-1 mb-0"
        />
        <RouterView />
      </v-main>
    </v-layout>
  </UserPermissionGuard>
</template>

<script setup lang="ts">
import { useDisplay } from 'vuetify'
import AppNavigationDrawer from '@/components/common/AppNavigationDrawer.vue'
import AppNavigationDrawerExpandButton from '@/components/common/AppNavigationDrawerExpandButton.vue'
import OpsTreeView from '@/components/ops/OpsTreeView.vue'
import UserPermissionGuard from '@/components/UserPermissionGuard.vue'

definePage({
  meta: { feature: 'ops', space: 'operations' },
})

const drawer = ref(false)

const { smAndDown } = useDisplay()

const { t } = useI18n()
</script>
